import { type ReactNode, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'components';
import { usePublishBottomNavbarHeight } from 'components/navbars/BottomNavbar';
import { ResultBottomBar } from './ResultBottomNavbar.styles';

interface ResultBottomNavBarProps {
  banner?: ReactNode;
  rightContent?: ReactNode;
  onDismiss: () => void;
}

export function ResultBottomNavBar({ banner, rightContent, onDismiss }: ResultBottomNavBarProps) {
  const { t } = useTranslation();
  const barRef = useRef<HTMLDivElement>(null);
  usePublishBottomNavbarHeight(barRef);

  return (
    <ResultBottomBar ref={barRef}>
      {banner}
      <div className="bg-white border-t border-border shadow-lg px-4 py-3">
        <div className="flex justify-between items-center w-full max-w-6xl mx-auto gap-2">
          <Button variant="secondary" data-ph-no-autocapture onClick={onDismiss}>
            {t('general.dismiss')}
          </Button>
          {rightContent}
        </div>
      </div>
    </ResultBottomBar>
  );
}
